export function buildFilterBody(contentType: string[], competition: string[], season: string[], dateRange: any) {
  const cleanContentType = contentType.filter(el => el !== 'All');
  const cleanCompetition = competition.filter(el => el !== 'All');
  const cleanSeason = season.filter(el => el !== 'All');

  return {
    contentType: cleanContentType.length === 1 ? cleanContentType[0] : cleanContentType,
    competition: cleanCompetition.length === 1 ? cleanCompetition[0] : cleanCompetition,
    season: cleanSeason.length === 1 ? cleanSeason[0] : cleanSeason,
    
    startDate: dateRange?.[0]?.format?.('YYYY-MM-DD') || dateRange?.[0] || null,
    endDate: dateRange?.[1]?.format?.('YYYY-MM-DD') || dateRange?.[1] || null,
  };
}

export const PLATFORM_COLORS: Record<string, string> = {
  'TIKTOK': '#010101',
  'INSTAGRAM': '#E1306C',
  'YOUTUBE': '#FF0000',
  'WHATSAPP': '#25D366',
  'FACEBOOK': '#0448a1',
  'TELEGRAM': '#26A5E4',
  'DAILYMOTION': '#2177da',
  'X': '#4cacec',
};